/**
 * Canonical TRA typography — ONLY two faces in the entire product.
 *
 * 1. PRIMARY — Geist (`--tra-font-family-display` / `--tra-font-family-body`)
 *    Heroes, subtitles, names, titles, body, buttons, numbers.
 * 2. LABEL — Geist Mono (`--tra-font-family-mono`)
 *    Eyebrows, KPI captions (MATCHES / WINS / LOSSES), chips, badges, meta labels.
 *
 * Forbidden: any third typeface (Inter, Poppins, JetBrains, Roboto, Segoe UI, Arial, …).
 * system-ui / monospace stacks may appear only as fallbacks after Geist / Geist Mono.
 *
 * Golden: reference_files/App_screenshots/Screenshot_20260714-131830.png (labels)
 *         reference_files/App_screenshots/Screenshot_20260714-131805.png (primary hero)
 */
export const fontFamily = {
  display: '"Geist", system-ui, sans-serif',
  body: '"Geist", system-ui, sans-serif',
  mono: '"Geist Mono", ui-monospace, monospace',
  numeric: '"Geist", tabular-nums, system-ui, sans-serif',
};

export const fontWeight = {
  regular: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
};

export const typographyScale = {
  display: { size: 32, lineHeight: 1.15, weight: fontWeight.semibold, family: "display" },
  h1: { size: 26, lineHeight: 1.2, weight: fontWeight.semibold, family: "display" },
  h2: { size: 22, lineHeight: 1.25, weight: fontWeight.semibold, family: "display" },
  h3: { size: 18, lineHeight: 1.3, weight: fontWeight.semibold, family: "display" },
  title: { size: 16, lineHeight: 1.35, weight: fontWeight.semibold, family: "body" },
  subtitle: { size: 14, lineHeight: 1.4, weight: fontWeight.medium, family: "display" },
  body: { size: 15, lineHeight: 1.5, weight: fontWeight.regular, family: "body" },
  small: { size: 13, lineHeight: 1.45, weight: fontWeight.regular, family: "body" },
  caption: { size: 11, lineHeight: 1.4, weight: fontWeight.regular, family: "body" },
  label: {
    size: 9,
    lineHeight: 1.3,
    weight: fontWeight.medium,
    family: "mono",
    letterSpacing: "0.12em",
  },
  /** Section eyebrows (“Your season”) — same mono voice, slightly larger than KPI labels. */
  sectionLabel: {
    size: 11,
    lineHeight: 1.3,
    weight: fontWeight.medium,
    family: "mono",
    letterSpacing: "0.12em",
  },
  mono: { size: 13, lineHeight: 1.45, weight: fontWeight.regular, family: "mono" },
  numeric: { size: 28, lineHeight: 1.1, weight: fontWeight.bold, family: "numeric" },
};

/** Shared CSS recipe for label voice. */
export const LABEL_CAPS_CSS = Object.freeze({
  fontFamily: "var(--tra-font-family-mono)",
  fontSize: "var(--tra-font-label-size, 9px)",
  fontWeight: 500,
  letterSpacing: "0.12em",
  textTransform: "uppercase",
});
